import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { postsAPI } from '../../services/api';
import ArticleModal from '../ArticleModal/ArticleModal';

const ArticleModalRoute = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const res = await postsAPI.getById(slug);
        if (!cancelled) setArticle(res.data);
      } catch (e) {
        if (!cancelled) setArticle(null);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (!article) return null;

  return <ArticleModal article={article} onClose={() => navigate(-1)} />;
};

export default ArticleModalRoute;
